import React, { Suspense } from 'react';
import BookingSpinner from './BookingSpinner';

/**
 * A minimal loading fallback for lazy-loaded components.
 * Used within dialogs/pages where the parent container already provides structure.
 * Uses the same ring as the facade / App fallback (compact 24px) for consistency.
 */
function LoadingFallback() {
  return <BookingSpinner size={24} height={100} />;
}

/**
 * Wrapper component for lazy-loaded components.
 * Provides a Suspense boundary with a consistent loading fallback.
 *
 * @param {React.ReactNode} children - The lazy-loaded component to render
 * @param {React.ReactNode} fallback - Optional custom fallback (defaults to LoadingFallback)
 */
export default function LazyComponent({ children, fallback }) {
  return (
    <Suspense fallback={fallback || <LoadingFallback />}>{children}</Suspense>
  );
}
